import { render, staticRenderFns } from "./CounselorDashboard.vue?vue&type=template&id=1abe2d09&scoped=true&"
import script from "./CounselorDashboard.vue?vue&type=script&lang=js&"
export * from "./CounselorDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CounselorDashboard.vue?vue&type=style&index=0&id=1abe2d09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abe2d09",
  null
  
)

export default component.exports